import uuid from "react-uuid"
export const fnSetDataLogin = (data) => {
    return {
        ...data.login,
        companies: data.company.map(x => ({id: x.id, name: `${x.companyName} (${x.storeName})`, uniqueKey :uuid() })),
        tgid: data.tgid,
        isLogin: true,
    }
}